import type { FilePublic } from '@repo/types/files';

import { useMemo } from 'react';

const MIME_BY_EXTENSION: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  pdf: 'application/pdf',
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogv: 'video/ogg',
  mpeg: 'video/mpeg',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  ogg: 'audio/ogg',
  flac: 'audio/flac',
};

/**
 * Builds the FilePublic the media viewer needs from a stored attachment, which
 * only carries id and name. The file type is inferred from the extension; the
 * viewer loads the bytes itself, so no metadata request is needed.
 */
export function useAttachmentFile(id: string, name: string): FilePublic {
  const extension = name.split('.').pop()?.toLowerCase() ?? '';
  const fileType = MIME_BY_EXTENSION[extension] ?? 'application/octet-stream';

  return useMemo(() => ({ id, name, fileType, thumbnail: null, createdAt: '', updatedAt: '' }), [id, name, fileType]);
}
